// Core
import { useState, useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { Box, Image, ChakraProvider, Portal, useDisclosure, useColorModeValue } from '@chakra-ui/react';

// Assets
import routes from '../routes.js';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import theme from '../theme/theme.js';
import { useQuery } from 'react-query';
import { apiService } from 'services/ApiService';
import chat from 'assets/img/chat.png';

// Components
import MainPanel from '../components/Layout/MainPanel';
import PanelContainer from '../components/Layout/PanelContainer';
import PanelContent from '../components/Layout/PanelContent';
import Navbar from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';

export default function Dashboard(props) {
  const { ...rest } = props;

  const [ fixed, setFixed ] = useState(false);
  const [ isSidebarStack, setSidebarStack ] = useState(false);

  const getRoute = () => {
    return window.location.pathname !== '/full-screen-maps';
  };

  const [isCheckedTypeAccount, setIsCheckedTypeAccount] = useState(false);

  useEffect(() => {
    const storedValue = localStorage.getItem('switchAccountType');
    if (storedValue !== null) {
      setIsCheckedTypeAccount(JSON.parse(storedValue)); 
    }
  }, []);

  const [object, setObject] = useState();
  const [findAgeFrom, setFindAgeFrom] = useState();
  const [findAgeTo, setFindAgeTo] = useState();
  const { refetch: refetchUser } = useQuery({
    queryKey: ['data-me'],
    queryFn: async () => {
      const response = await apiService.getMe();
      setObject(response.data);
      setFindAgeFrom(response?.data?.findAge[0] || 18);
      setFindAgeTo(response?.data?.findAge[1] || 60);
      return true;
    },
    refetchOnWindowFocus: false,
    retry: false,
  });

  const getActiveRoute = (routes) => {
    const activeRoute = '';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        const collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        const categoryActiveRoute = getActiveRoute(routes[i].views);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  // This changes navbar state(fixed or not)
  const getActiveNavbar = (routes) => {
    const activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].category) {
        const categoryActiveNavbar = getActiveNavbar(routes[i].views);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          if (routes[i].secondaryNavbar) {
            return routes[i].secondaryNavbar;
          }
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/') {
        return <Route path={prop.layout + prop.path} key={key}>
          { routerProps => 
              <prop.component {...routerProps} 
                object={object} 
                setObject={setObject}
                findAgeFrom={findAgeFrom}
                setFindAgeFrom={setFindAgeFrom}
                findAgeTo={findAgeTo}
                setFindAgeTo={setFindAgeTo}
                refetchUser={refetchUser}
                isCheckedTypeAccount={isCheckedTypeAccount}
                setIsCheckedTypeAccount={setIsCheckedTypeAccount} />
          }
        </Route>;
      } else {
        return null;
      }
    });
  };
  const { isOpen, onOpen, onClose } = useDisclosure();

  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);

  // Chakra Color Mode
  return (
    <ChakraProvider theme={theme} resetCss={false}>
      { isActive('messages/') &&
        <Box w="100%" h="100%" position="absolute" zIndex="9" top="0px">
          <Image src={chat} h="100%" w="100%" filter="grayscale(1)" objectFit="cover" />
        </Box>
      }
      <MainPanel
        transition='unset !important'
        w={{ base: '100%' }}
        left={{ base: '0' }}
        maxWidth="1440px"
        float="unset"
        alignItems="center"
        justifyContent="center"
        m="0px auto 0 auto"
      >
        <Portal>
          <Navbar
            routes={routes}
            onOpen={onOpen}
            brandText={getActiveRoute(routes)}
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            isCheckedTypeAccount={isCheckedTypeAccount}
            setIsCheckedTypeAccount={setIsCheckedTypeAccount}
            object={object} 
            setObject={setObject}
            findAgeFrom={findAgeFrom}
            setFindAgeFrom={setFindAgeFrom}
            findAgeTo={findAgeTo}
            refetchUser={refetchUser}
            setFindAgeTo={setFindAgeTo}
            {...rest}
          />
        </Portal>
        { getRoute() ? (
          <PanelContent>
            <PanelContainer>
              <Switch>
                {getRoutes(routes)}
                <Redirect from='/' to={routes[0].path} />
              </Switch>
            </PanelContainer>
          </PanelContent>
        ) : null}
        <Footer
          object={object} 
          isCheckedTypeAccount={isCheckedTypeAccount}
          setIsCheckedTypeAccount={setIsCheckedTypeAccount}
          />
      </MainPanel>
    </ChakraProvider>
  );
}
